import {  Grid, TextField, Button, IconButton , Checkbox} from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState ,useEffect} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import StatusDisplay from './StatusDisplay'
import { AssociateSoftwareToken,VerifySoftwareToken,SetUserMFAPreference,updateEmail,updatePhone} from '../Services/authService';
import QRCode from "react-qr-code";


const useStyles = makeStyles((theme) => ({
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: 160,
        height: 40,
        color: '#FFFFFF',
        margin: 20,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    }
}));

const ManageMFADialog = ( {open,userInfo,username,signinlabel,closeCallback,authInfo
        ,isRunning,setIsRunning,successMessage,setSuccessMessage,error,setError
        ,handleError} )=>{

    const classes = useStyles();
    const findInArray= (arr,key,value)=>{
        for(var i=0;i<arr.length;i++){
            if(arr[i][key]===value) return arr[i];
        }
        return null;
    };

    let [cognitoResult, setCognitoResult] = useState();
    let [sms_enabled, setsms_enabled] = useState();
    let [email_enabled, setemail_enabled] = useState(false);
    let [authapp_enabled, setauthapp_enabled] = useState(false);

    let [userPhone, setuserPhone] = useState("");
    let [userEmail, setuserEmail] = useState("");
    
    useEffect( () => {
            var emailObj =  (userInfo)? findInArray(userInfo.data.UserAttributes,"Name","email" ):null;
            var customMFA = (userInfo)? findInArray(userInfo.data.UserAttributes,"Name","custom:mfapreference"):null;
            setuserEmail((emailObj)?emailObj.Value:"");
            setemail_enabled((customMFA && customMFA.Value && customMFA.Value==="EMAIL")?true:false);

            var phoneObj = (userInfo)? findInArray(userInfo.data.UserAttributes,"Name","phone_number" ):null; 
            setuserPhone((phoneObj)?phoneObj.Value:"");

            if(!userInfo || userInfo.data.UserMFASettingList.length===0){
                setsms_enabled(false);
                setauthapp_enabled(false);

            }else if(userInfo.data.UserMFASettingList.length===1){
                setsms_enabled((userInfo.data.UserMFASettingList[0]==="SMS_MFA")? true:false);
                setauthapp_enabled((userInfo.data.UserMFASettingList[0]==="SOFTWARE_TOKEN_MFA")? true:false);
            }else{
                setsms_enabled(true);
                setauthapp_enabled(true);
            }
        },
        [userInfo]
    );


    const handleClose=(writeAuth)=>{
        closeCallback(writeAuth);
    };
    const handleCancel=(writeAuth)=>{
        closeCallback(false);
    };

    const handleVerifyAuthApp = (e)=>{
        setError("");
        var friendlyName = "";
        var verifyCode = document.getElementById('txtauthappfusercode').value;
        setIsRunning(true);
        VerifySoftwareToken(authInfo.data.AuthenticationResult.AccessToken,friendlyName,verifyCode).then(result=>{
            console.log(result);
            cognitoResult=result;setCognitoResult(result);
            authapp_enabled=true;setauthapp_enabled(true);
            handleMFAPref(null,true);
        }).catch(error=>{
            handleError(null,error);
        }).finally(()=>{ 
            setIsRunning(false);                
        });
    }

    const handleVerifySMS = (e)=>{
        setError("");
        setIsRunning(true);
        updatePhone(authInfo.data.AuthenticationResult.AccessToken,userPhone).then(result=>{
            console.log(result);
//            cognitoResult=result;
//            setCognitoResult(result);
        }).catch(error=>{
            handleError(null,error);
        }).finally(()=>{ 
            setIsRunning(false);                
        });
    }
    const handleVerifyEmail = (e)=>{
        setError("");
        setIsRunning(true);
        updateEmail(authInfo.data.AuthenticationResult.AccessToken,userEmail).then(result=>{
            console.log(result);
            // cognitoResult=result;
            // setCognitoResult(result);
        }).catch(error=>{
            handleError(null,error);
        }).finally(()=>{ 
            setIsRunning(false);                
        });
    }
    const handleRegisterAuthApp = (e)=>{
        setError("");
        setIsRunning(true);
        AssociateSoftwareToken(authInfo.data.AuthenticationResult.AccessToken).then(result=>{
            console.log(result);
            cognitoResult=result;
            setCognitoResult(result);
        }).catch(error=>{
            handleError(null,error);
        }).finally(()=>{ 
            setIsRunning(false);                
        });
    }    
    const handleMFAPref = (e,setAuthApp)=>{
        setError("");
        if(!sms_enabled && !authapp_enabled && !email_enabled){
            handleError('MFAREQUIRED');
        }else{
            setIsRunning(true);
            SetUserMFAPreference(authInfo.data.AuthenticationResult.AccessToken,sms_enabled,authapp_enabled,email_enabled).then(result=>{
                console.log("SetUserMFAPreference: ", result);
                cognitoResult=result;
                setCognitoResult(result);
                handleClose(true);
            }).catch(error=>{
                handleError(null,error);
            }).finally(()=>{ 
                setIsRunning(false);                
            });
        }
    }
    const setEnabled = (e)=>{
        console.log(e);
        if(e.target.name ==="mfapref_sms_enabled"){
            setsms_enabled(true);
            setemail_enabled(false);
            setauthapp_enabled(false);
        }
        if(e.target.name ==="mfapref_authapp_enabled"){
            setauthapp_enabled(true);
            setsms_enabled(false);
            setemail_enabled(false);
        }
        if(e.target.name ==="mfapref_email_enabled"){
            setemail_enabled(true);
            setsms_enabled(false);
            setauthapp_enabled(false);
        }
    }
    return (
        <Dialog fullWidth={true} open={open} maxWidth='sm' disableBackdropClick disableEscapeKeyDown  aria-labelledby="max-width-dialog-title">
            <Grid item xs={12} container>
                <Grid item xs={11}> <DialogTitle id="verify-authapp-user-dilaog">{signinlabel.MANAGE_MFA}</DialogTitle> </Grid>
                <Grid item xs={1}> <IconButton onClick={handleCancel}> <CloseIcon /> </IconButton> </Grid>
            </Grid>
        <DialogContent>                                    
            <div style={{ marginBottom: '20px', marginLeft: '10px', marginRight: '10px', height: '570px', width: '530px' }}>
                <StatusDisplay isRunning={isRunning}  successMessage={successMessage} setSuccessMessage={setSuccessMessage} error={error} setError={setError} ></StatusDisplay>
                {(cognitoResult && cognitoResult.data && cognitoResult.data.SecretCode)?(
                    <div>
                        <h3>{signinlabel.SCANQR}</h3>
                        <QRCode value={"otpauth://totp/AWSCognitoAWSCognito:" + username + "?secret=" + cognitoResult.data.SecretCode + "&issuer=Cognito"} />                                    
                        <h3>{signinlabel.ENTERCODE}</h3>
                        <div>{cognitoResult.data.SecretCode}</div>
                        <br/>
                    </div>
                ):("")}
                { (cognitoResult && cognitoResult.data && cognitoResult.data.SecretCode)? (
                    <div>
                        <br/>
                        <div className={classes.usernamelbl}>
                            <label>{signinlabel.CodeLabelTxt}</label><br></br>
                            <TextField id="txtauthappfusercode" name="txtauthappfusercode" variant="outlined" type="text" className={classes.usernametxt}   />
                        </div>
                        <Button variant="contained" color="primary" onClick={handleVerifyAuthApp} className={classes.signinbtn}>{signinlabel.MFA_VERIFY}</Button>
                    </div>
                ):("")}
                { (userPhone)? (
                <div> <h4>{signinlabel.SelectMFA_SMS}  </h4>
                    <div>
                        {signinlabel.MFA_PREFERENCE_ENABLED}: 
                        <Checkbox id="mfapref_sms_enabled" name="mfapref_sms_enabled" checked={sms_enabled} onChange={setEnabled} ></Checkbox>
                        {userPhone}
                        
                    </div>
                </div>
                ):("")}
                <div><h4>{signinlabel.SelectMFA_APP}</h4>
                    <div>
                        {signinlabel.MFA_PREFERENCE_ENABLED}:<Checkbox id="mfapref_authapp_enabled" name="mfapref_authapp_enabled" checked={authapp_enabled} onChange={setEnabled} ></Checkbox>
                        <Button variant="contained" color="primary" onClick={handleRegisterAuthApp} className={classes.signinbtn}>{signinlabel.REGISTER_APP}</Button><a href="/AuthAppInstructions" target='_blank'>Instructions</a>
                    </div>
                </div>
                <div> <h4>{signinlabel.SelectMFA_EMAIL}  </h4>
                    <div>
                        {signinlabel.MFA_PREFERENCE_ENABLED}: 
                        <Checkbox id="mfapref_email_enabled" name="mfapref_email_enabled" checked={email_enabled} onChange={setEnabled} ></Checkbox>
                        {userEmail}
                    </div>
                </div>
                <Button variant="contained" color="primary" onClick={handleMFAPref} className={classes.signinbtn}>{signinlabel.MFA_PREFERENCE_SAVE}</Button>

            </div>
        </DialogContent>
    </Dialog>
    );
}
export default ManageMFADialog;